import { Box, Button } from "@mui/material";
import "./App.css";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";

import Navbar from "./components/UI/Navbar/Navbar";
import ServerlessComputing from "./components/ServerlessComputing/ServerlessComputing";
import Sidebar from "./components/UI/Sidebar/Sidebar";

import Logout from "./components/Auth/Logout/Logout";
import Footer from "./components/Footer/Footer";
import { usePageController } from "./store/PageController";
import ContentBar from "./components/ServerlessComputing/components/Documentation/ContentBar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Subscribe from "./components/Auth/Subscribe/Subscribe";
import Login from "./components/Auth/Login/Login";
import Reset from "./components/Auth/Reset/Reset";
import Confirmation from "./components/Auth/Confirmation/Confirmation";

//ROBOTO FONT LOAD
import "@fontsource/roboto";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import FeedbackForm from "./components/Feedback/FeedbackForm";
import { useUserStore } from "./store/UserStore";
import { useEffect } from "react";
import Layout from "./components/ServerlessComputing/Layout";
import Product from "./components/Product/Product";

function App() {
  return (
    <>
      <Navbar />

      <Routes>
        <Route path="/" element={<Layout />} />
        <Route path="/about" element={<About />} />
        <Route path="/subscribe" element={<Subscribe />} />
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/reset" element={<Reset />} />
        <Route path="/confirmation" element={<Confirmation />} />
        <Route path="/feedback" element={<FeedbackForm />} />
        //<Route path="/serverless-computing" element={<Layout />} />
        <Route path="/product" element={<Product />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;
